import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { darkActionButton } from '../styles/project-styles';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AddLessonModal(props) {

  const [open, setOpen] = React.useState(false);
  useEffect(()=>{
    let pop_status = localStorage.getItem('pop_status');
    if(!pop_status){
      setOpen(true);
      localStorage.setItem('pop_status',1);
    }
  },[])
  if(!open) return null;

  // const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2, width: '80vw' }} id="customized-dialog-title">
          🕵️ Chasse aux bugs ! 🕵️
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography>
            Salut !
          </Typography>
          <br />
          <Typography>
            De temps en temps notre magicien 🧙‍♂️ fait des bêtises et il peut arriver que des petites erreurs se glissent dans les questions des quiz. 😩
          </Typography>
          <br />
          <Typography>
          Si tu en trouves une, tu peux nous aider en cliquant sur le lien "Signaler un problème" en bas de l'écran de chaque question de quiz.
          </Typography>
          <br />
          <Typography>
            Bonne chasse ! 🕵️
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Ok c'est parti !
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
